import { render, staticRenderFns } from "./onjobtraining.vue?vue&type=template&id=81183784&lang=html"
import script from "./onjobtraining.vue?vue&type=script&lang=js"
export * from "./onjobtraining.vue?vue&type=script&lang=js"
import style0 from "./onjobtraining.vue?vue&type=style&index=0&id=81183784&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports